import Utils from '../framework/utils';

// The app takes its access token from the Auth0 SDK and never reads the `token` cookie. It still
// writes it, because other Chartboost dashboards on the same domain read it.

const removeAllCookies = () => {
  const DOMAIN = process.env.REACT_APP_DOMAIN || '.chartboost.com';

  document.cookie.split(';').forEach(function (c) {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, `=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${DOMAIN}`);
  });
};

export const setAuthToken = (token) => {
  try {
    Utils.setCookie('token', token);
  } catch (err) {
    return false;
  }
};

export const deleteAuthToken = () => {
  try {
    removeAllCookies();
    return '';
  } catch (err) {
    return '';
  }
};
